// @flow
import { post, get } from './common';
import { handleAPIErrors } from '../sentry-util';

export const fetchOrders = async (mobile: string, page: string, session: string) => {
	try {
		const res = await post('/customer/app/getorderhistory', { mobile, page }, { session });
		const { data = [], status, msg } = res;
		if (!status) {
			throw new Error(msg || 'Error while fetching orders');
		}
		return data;
	} catch (error) {
		// console.error(error);
		throw error;
	}
};

export const fetchLastOrder = async (mobile: string, sessionId: string) => {
	try {
		const data = await post('/o/i', { mobile });
		return data.last_order;
	} catch (error) {
		// console.error(error);
		throw error;
	}
};

export const fetchOrderInvoice = async (
	{ orderId, type = 'ORDER_ID' }: { orderId: string, type: string },
	session: string
) => {
	try {
		let res;
		if (type === 'ACCESS_CODE') {
			res = await get(
				`/customer/app/getorderbyaccesscode`,
				{
					access_code: orderId
				},
				{ session }
			);
		} else {
			res = await get(
				`/customer/app/getorderdetails/`,
				{
					order_id: orderId
				},
				{ session }
			);
		}

		const { data = {}, status, msg } = res;
		if (!status || !data) {
			throw new Error(msg || 'Error while fetching order');
		}

		const parsedData = Object.values(data) || [];
		return parsedData[0] || {};
	} catch (error) {
		handleAPIErrors(error, '/customer/app/getorderdetails/', 'GET', {
			order_id: orderId
		});
		throw error;
	}
};

export const fetchPendingOrders = async (mobile: string, session: string) => {
	try {
		const res = await get('/customer/app/getactiveorder', { user_id: mobile }, { session });
		const { data } = res;
		return data ? [data] : [];
	} catch (error) {
		handleAPIErrors(error, '/customer/app/getactiveorder', 'GET', { user_id: mobile });
		throw error;
	}
};

export const cancelOrder = async (orderId: string, session: string) => {
	try {
		const res = await post('/customer/app/updateOrderStatus', { order_id: orderId, status: 'c' }, { session });
		const { status, msg } = res;
		if (!status) {
			// Use API response message if available, otherwise fallback to hardcoded message
			const errorMessage = msg && msg.trim() ? msg : 'Error while cancelling active order';
			throw new Error(errorMessage);
		}
		return res;
	} catch (error) {
		handleAPIErrors(error, '/customer/app/updateOrderStatus', 'POST', { order_id: orderId, status: 'c' });
		throw error;
	}
};

export const cancelVSOrder = async (orderId: string, session: string) => {
	try {
		const res = await post('/vs/order/cancel', { orderId }, { session });
		const { status } = res;
		if (!status) {
			throw new Error('Error while cancelling your order');
		}
		return res;
	} catch (error) {
		handleAPIErrors(error, '/vs/order/cancel', 'POST', { orderId });
		throw error;
	}
};
